import { createSelector } from '@ngrx/store';
import { State } from '@state/core.state';
import { projectDetailsPageStateKey } from '../state';

export const selectFeature = (state: State) => state[projectDetailsPageStateKey];

export const numberOfLanes = createSelector(selectFeature, (state) => state.numberOfLanes);

export const loadingLanesList = createSelector(selectFeature, (state) => state.loadingLanesList);

export const capacitySearchResults = createSelector(
	selectFeature,
	(state) => state.capacitySearchResults
);
export const truckSearchResult = createSelector(selectFeature, (state) => state.truckSearchResult);
export const userCarrierMapList = createSelector(
	selectFeature,
	(state) => state.userCarrierMapList
);
export const recommendedCarriersProjectsList = createSelector(
	selectFeature,
	(state) => state.recommendedCarriersProjectsList
);

export const userCarrierMap = createSelector(selectFeature, (state) => state.userCarrierMap);
export const recommendedCarriersProjectMap = createSelector(
	selectFeature,
	(state) => state.recommendedCarriersProjectMap
);

export const truckLaneSearchId = createSelector(selectFeature, (state) => state.truckLaneSearchId);

export const capacitySearchCsvDownloadInProgress = createSelector(
	selectFeature,
	(state) => state.capacitySearchCsvDownloadInProgress
);

export const bestMatch = createSelector(selectFeature, (state) => state.bestMatch);

export const hasLane = createSelector(selectFeature, (state) => state.hasLane);

export const filters = createSelector(selectFeature, (state) => {
	return {
		originDeadhead: state.originDeadhead,
		destinationDeadhead: state.destinationDeadhead,
		powerUnits: state.powerUnits,
		minLoadsPerWeek: state.minLoadsPerWeek,
		ratesOnly: state.ratesOnly,
		carrierMc: state.carrierMc,
		carrierDot: state.carrierDot,
		carrierBusinessName: state.carrierBusinessName,
		carrierHQ: state.carrierHQ,
		myCarriers: state.myCarriers,
		carrierSearchString: state.carrierSearchString,
		outOfNetworkCarriers: state.outOfNetworkCarriers,
		qualityFilter: state.qualityFilter,
	};
});

export const customerOnlyProject = createSelector(
	selectFeature,
	(state) => state.customerOnlyProject
);
